<template>
<svg width="18px" height="21px" viewBox="0 0 18 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="btn_Primary-default" transform="translate(-226.000000, -23.000000)" fill="currentColor">
            <g id="btn_Primary">
                <g id="Planning-/-Time-/-calendar-/-24" transform="translate(223.000000, 22.000000)">
                    <path d="M19.5,3.0225 L16.5,3.0225 L16.5,1.5225 L15,1.5225 L15,3.0225 L9,3.0225 L9,1.5225 L7.5,1.5225 L7.5,3.0225 L4.5,3.0225 C3.67157288,3.0225 3,3.69407288 3,4.5225 L3,19.5225 C3,20.3509271 3.67157288,21.0225 4.5,21.0225 L19.5,21.0225 C20.3284271,21.0225 21,20.3509271 21,19.5225 L21,4.5225 C21,3.69407288 20.3284271,3.0225 19.5,3.0225 Z M19.5,19.5225 L4.5,19.5225 L4.5,9.0225 L19.5,9.0225 L19.5,19.5225 Z M19.5,7.5225 L4.5,7.5225 L4.5,4.5225 L7.5,4.5225 L7.5,6.0225 L9,6.0225 L9,4.5225 L15,4.5225 L15,6.0225 L16.5,6.0225 L16.5,4.5225 L19.5,4.5225 L19.5,7.5225 Z" id="Fill"></path>
                </g>
            </g>
        </g>
    </g>
</svg>
</template>

<script>
export default {
  name: 'Calendar'
};
</script>
